import { render, staticRenderFns } from "./WsStateSwitchTab.vue?vue&type=template&id=350b2abe&"
import script from "./WsStateSwitchTab.vue?vue&type=script&lang=js&"
export * from "./WsStateSwitchTab.vue?vue&type=script&lang=js&"
import style0 from "./WsStateSwitchTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports